import { OverlayView } from "@react-google-maps/api";
import { Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C2Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { useState } from "react";
import MapMarkerTooltip from "./MapMarkerTooltip";
import { Theme } from "../../../common/Theme";

function MapMarkerLabel({ position, shopCode, name, washers, dryers, combos, phone, images }) {
    const [showDetailTooltip, setShowDetailTooltip] = useState(false);
    const toggleDetailTooltip = () => setShowDetailTooltip(!showDetailTooltip);

    return (
        <OverlayView position={position} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
            <div style={{ position: "relative" }}>
                <div
                    style={{
                        width: "210px",
                        height: "42px",
                        cursor: "pointer",
                    }}
                    onClick={toggleDetailTooltip}
                >
                    <Row
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: showDetailTooltip ? Theme.color.indigo500 : Theme.color.white,
                            border: `1px solid ${Theme.color.indigo500}`,
                            borderRadius: "50px",
                            padding: "10px 16px",
                        }}
                        cursor={"pointer"}
                    >
                        <CustomIcon
                            iconName={showDetailTooltip ? "shop_marker_active" : "shop_marker"}
                            size={"20px"}
                            cursor={"pointer"}
                        />
                        <SizedBox width={"8px"} />
                        <C2Text
                            fontWeight={"500"}
                            fontColor={showDetailTooltip ? Theme.color.white : Theme.color.zinc850}
                            useEllipsis={true}
                            style={{ flex: 1 }}
                        >
                            {name}
                        </C2Text>
                    </Row>
                </div>
                <MapMarkerTooltip
                    isOpen={showDetailTooltip}
                    onClose={() => setShowDetailTooltip(false)}
                    shopCode={shopCode}
                    name={name}
                    contact={phone}
                    activeWasher={washers[0]}
                    deactivatedWasher={washers[1]}
                    activeDryer={dryers[0]}
                    deactivatedDryer={dryers[1]}
                    activeCombo={combos[0]}
                    deactivatedCombo={combos[1]}
                    images={images}
                ></MapMarkerTooltip>
            </div>
        </OverlayView>
    );
}

export default MapMarkerLabel;
